import { Expose } from "class-transformer";

export class UpdateOfferDto {
  @Expose()
  code: string;

  @Expose()
  url?: boolean;
}
